var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-card"},[_c('button',{staticClass:"cart-delete",attrs:{"type":"button"},on:{"click":_vm.onDeleteOption}},[_vm._v("カートから削除する")])])}
var staticRenderFns = []

export { render, staticRenderFns }